import React from "react";
import "./Style.css";
import { useRef } from "react";
import axios from "axios";
import icon from "./icons/icon.png";
import Button from "../../Button/Button";
import { useGlobalContext } from "../../Context/Context";

const SendMyselfOrTrustedUser = ({
  setCurrentPage,
  setCurrentPagePassword,
}) => {
  const { controlEmail, baseUrl, letterSize, boldItalic, setFromEnterCode } = useGlobalContext();
  const controlOtherUserEmail = useRef("");
  const { typeButton, fontSize, fontStyle } = useGlobalContext();

  console.log(controlEmail);

  const handleSendMYCode = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/verification_codes/send_verification_code.php`,
        {
          user_email: controlEmail,
        }
      );
      console.log(data);
      if (data.status === 200) {
        setFromEnterCode(true);
        setCurrentPagePassword(1);
      } else {
        setCurrentPage(0);
      }
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSendOtherCode = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/recovery_codes/sendEmail.php`,
        {
          user_email: controlEmail,
          trusted_contact_email: controlOtherUserEmail.current,
        }
      );
      console.log(data);
      if (data.status === 200) {
        setCurrentPagePassword(1);
      } else {
        setCurrentPage(0);
      }
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleConvertText = (text) => {
    console.log(text);
    if (letterSize === undefined || letterSize === null) {
      return text;
    }
    if (letterSize === 0) {
      return text.toUpperCase();
    }
    if (letterSize === 1) {
      return text[0].toUpperCase() + text.slice(1).toLowerCase();
    }
    if (letterSize === 2) {
      return text.toLowerCase();
    }
  };

  const handleInputOtherUser = (e) => {
    controlOtherUserEmail.current = e.currentTarget.value;
    console.log(controlOtherUserEmail);
  };

  console.log(controlOtherUserEmail);

  return (
    <div className="send-myself-or-trusted-user-container">
      <div className="message-top">
        <p
          className={
            `font-size-${parseInt(
              fontSize === undefined || fontSize === null ? 0 : fontSize / 3
            )}` +
            ` font-style-${parseInt(
              fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3
            )}`
          }
          style={
            boldItalic.find((element) => parseInt(element) === 2) !== undefined
              ? {
                  fontWeight: "normal",
                  fontStyle: "normal",
                }
              : boldItalic.find((element) => parseInt(element) === 1) !==
                  undefined &&
                boldItalic.find((element) => parseInt(element) === 0) !==
                  undefined
              ? {
                  fontWeight: "bold",
                  fontStyle: "italic",
                }
              : boldItalic.find((element) => parseInt(element) === 0) !==
                undefined
              ? {
                  fontStyle: "italic",
                }
              : boldItalic.find((element) => parseInt(element) === 1) !==
                undefined
              ? {
                  fontWeight: "bold",
                }
              : {
                  fontWeight: "normal",
                  fontStyle: "normal",
                }
          }
        >
          {handleConvertText(
            "KOD će stići na vasu email adresu, molimo vas da isti unesete u polja u prvom pokusaju."
          )}
        </p>
      </div>

      <div className="send-code-btn" onClick={handleSendMYCode}>
        <Button
          activation={true}
          typeButton={typeButton}
          className={
            `font-size-${parseInt(
              fontSize === undefined || fontSize === null ? 0 : fontSize / 3
            )}` +
            ` font-style-${parseInt(
              fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3
            )}`
          }
          style={
            boldItalic.find((element) => parseInt(element) === 2) !== undefined
              ? {
                  fontWeight: "normal",
                  fontStyle: "normal",
                }
              : boldItalic.find((element) => parseInt(element) === 1) !==
                  undefined &&
                boldItalic.find((element) => parseInt(element) === 0) !==
                  undefined
              ? {
                  fontWeight: "bold",
                  fontStyle: "italic",
                }
              : boldItalic.find((element) => parseInt(element) === 0) !==
                undefined
              ? {
                  fontStyle: "italic",
                }
              : boldItalic.find((element) => parseInt(element) === 1) !==
                undefined
              ? {
                  fontWeight: "bold",
                }
              : {
                  fontWeight: "normal",
                  fontStyle: "normal",
                }
          }
        >
          {handleConvertText("POŠALJI MI KOD")}
        </Button>
      </div>

      <div className="message-bottom">
        <p
          className={
            `font-size-${parseInt(
              fontSize === undefined || fontSize === null ? 0 : fontSize / 3
            )}` +
            ` font-style-${parseInt(
              fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3
            )}`
          }
          style={
            boldItalic.find((element) => parseInt(element) === 2) !== undefined
              ? {
                  fontWeight: "normal",
                  fontStyle: "normal",
                }
              : boldItalic.find((element) => parseInt(element) === 1) !==
                  undefined &&
                boldItalic.find((element) => parseInt(element) === 0) !==
                  undefined
              ? {
                  fontWeight: "bold",
                  fontStyle: "italic",
                }
              : boldItalic.find((element) => parseInt(element) === 0) !==
                undefined
              ? {
                  fontStyle: "italic",
                }
              : boldItalic.find((element) => parseInt(element) === 1) !==
                undefined
              ? {
                  fontWeight: "bold",
                }
              : {
                  fontWeight: "normal",
                  fontStyle: "normal",
                }
          }
        >
          {handleConvertText(
            "   KOD ce stici na email adresu navedenog pouzdanog kontakta, molimo vas da isti unesete u polja u prvom pokusaju."
          )}
        </p>
      </div>

      <div className="enter-contact">
        <img src={icon} alt="" />
        <input
          className="send-trust-user-input"
          type="text"
          onChange={handleInputOtherUser}
        />
      </div>

      <div className="send-code-to-contact-btn" onClick={handleSendOtherCode}>
        <Button
          activation={true}
          typeButton={typeButton}
          className={
            `font-size-${parseInt(
              fontSize === undefined || fontSize === null ? 0 : fontSize / 3
            )}` +
            ` font-style-${parseInt(
              fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3
            )}`
          }
          style={
            boldItalic.find((element) => parseInt(element) === 2) !== undefined
              ? {
                  fontWeight: "normal",
                  fontStyle: "normal",
                }
              : boldItalic.find((element) => parseInt(element) === 1) !==
                  undefined &&
                boldItalic.find((element) => parseInt(element) === 0) !==
                  undefined
              ? {
                  fontWeight: "bold",
                  fontStyle: "italic",
                }
              : boldItalic.find((element) => parseInt(element) === 0) !==
                undefined
              ? {
                  fontStyle: "italic",
                }
              : boldItalic.find((element) => parseInt(element) === 1) !==
                undefined
              ? {
                  fontWeight: "bold",
                }
              : {
                  fontWeight: "normal",
                  fontStyle: "normal",
                }
          }
        >
          {handleConvertText("POŠALJI KOD KONTAKTU")}
        </Button>
      </div>
    </div>
  );
};

export default SendMyselfOrTrustedUser;
